import styles from './index.module.scss';
import Link from 'next/link';

export default function ProductSpecification({ productInfoCardData }) {

const {productsCards = [] } = productInfoCardData || {};
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>PRODUCT SPECIFICATION</h2>
        <div className={styles.grid}>
          {productsCards?.map((item) => {
            const { sys, fields } = item;
                const {
                title,
                skuId,
                imageUrl,
                url,
                } = fields || {};
            return (
                <div key={sys.id} className={styles.tile}>
                <Link href={url || '#'}>
                    <div className={styles.card}>
                    
                    <div className={styles.imageBox}>
                        <img src={imageUrl} alt={skuId} />
                    </div>
                    <span className={styles.name}>
                        {title}
                    </span>
                    <span className={styles.sku}>
                        {skuId}
                    </span>
                    </div>
                </Link>
                </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}